
import React, {Component} from 'react';
import {Tab, Tabs} from 'material-ui';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import EditTagIcon from 'material-ui-icons/BorderColor';
import TranslateTagIcon from 'material-ui-icons/Translate';
import ViewTagIcon from 'material-ui-icons/Visibility';
import TagEdit from './TagEdit';
import TagView from './TagView';
import TagTranslationsList from './translations/TagTranslationsIndex';
import {setTagsTab} from '../layout/actions';
import {
    fetchVocabularyLevels,
    fetchTagParents,
    fetchTag,
    fetchTagTranslations
} from './thunks';
import {
    canEditOrViewGlobal
} from '../../components/permissions/permissions';

const EditTagActiveTab = (props) => (<TagEdit tag={props.tag} />)
const ViewTagActiveTab = (props) => (<TagView tag={props.tag} />)

let EditOrViewTagActiveTab = canEditOrViewGlobal(EditTagActiveTab, ViewTagActiveTab);

class TagEditTabs extends Component {

    async componentWillMount() {
        await this.props.fetchTag(this.props.match.params.id);
        await this.props.fetchTagTranslations(this.props.match.params.id);
        if (this.props.tag.id) {
            await this.props.fetchVocabularyLevels(this.props.tag.vocabulary_id);
            await this.props.fetchTagParents(this.props.tag.vocabulary_id, this.props.tag.level);
        }
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleChange = (event, value) => {
        this.props.setTagsTab(value, this.props.match.params.id);
    };

    render() {

        const {
            activeTabData,
            tag,
            tagTranslations
        } = this.props;

        let activeTab = 0;

        if (activeTabData[this.props.match.params.id]) {
            activeTab = activeTabData[this.props.match.params.id];
        }

        const EditTagTab = () => (
            <Tabs
                value={activeTab}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab icon={<EditTagIcon />} label="Edit Tag" />
                <Tab icon={<TranslateTagIcon />} label="Translations" />
            </Tabs>
        )

        const ViewTagTab = () => (
            <Tabs
                value={activeTab}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab icon={<ViewTagIcon />} label="View Tag" />
                <Tab icon={<TranslateTagIcon />} label="Translations" />
            </Tabs>
        )

        let EditOrViewTagTab = canEditOrViewGlobal(EditTagTab, ViewTagTab);

        return (
            <div>
                <EditOrViewTagTab />
                {activeTab === 0 && tag &&
                    <EditOrViewTagActiveTab
                        tag={tag}
                    />
                }
                {activeTab === 1 && tag &&
                    <TagTranslationsList
                        tag={tag}
                        tagTranslations={tagTranslations}
                    />
                }
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    activeTabData: state.layout.activeTagsTab,
    tag: state.tags.tag,
    tagTranslations: state.tags.tagTranslations,
});

export default connect(mapStateToProps, {
    setTagsTab,
    fetchTag,
    fetchTagTranslations,
    fetchVocabularyLevels,
    fetchTagParents,
})(TagEditTabs);



// WEBPACK FOOTER //
// ./src/containers/tags/TagEditTabs.jsx